import { render, staticRenderFns } from "./OrderViewActionsSpecAwaitingServicesCompleted.vue?vue&type=template&id=b0b08fc0&"
import script from "./OrderViewActionsSpecAwaitingServicesCompleted.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionsSpecAwaitingServicesCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports